/**
 * The PIN that opens the apps on a device already signed in (docs/architecture.md): six digits, asked again when the
 * apps open or come back after `pinIdleMinutes` away. The password signs in; the PIN only opens a signed-in session.
 */
export const pinLength = 6

/** Minutes without asking anything of the API (the apps closed, or out of sight) before the PIN is asked again */
export const pinIdleMinutes = 5

/** Wrong PINs in a row on one device before it is signed out: back to the password */
export const pinTries = 5

/** Six digits */
export const isPin = (value: string) => new RegExp(`^\\d{${pinLength}}$`).test(value)

/** Too easy to guess: one digit throughout (000000) or digits in a row, up or down (123456, 987654) */
export function weakPin(pin: string): boolean {
  const steps = new Set(Array.from(pin.slice(1), (digit, i) => (Number(digit) - Number(pin[i]) + 10) % 10))
  return steps.size === 1 && [0, 1, 9].includes([...steps][0] ?? -1)
}

/**
 * How long a super admin looks at the apps as someone else, read only, at most (apps/api/src/auth/view-as.ts); ended
 * sooner from the badge over the apps
 */
export const viewAsMinutes = 30
